import { SpeciesType } from 'shared/types/graphql';

export enum PhoneCallParticipantEventEntity {
  Appointment = 'Appointment',
  ServiceReminder = 'Service Reminder',
}

export interface PhoneCallParticipantEvent {
  eventEntity: PhoneCallParticipantEventEntity;
  eventEntityId?: string;
  eventName: string;
  timestamp: Date;
  isPastDue?: boolean;
  petId: string;
  petName: string;
  petSpeciesType: SpeciesType;
}
